import { addMonths, format } from 'date-fns';

/** Сколько месяцев календарь показывает рядом — всегда в один ряд. */
export const VISIBLE_MONTHS_COUNT = 2;

export interface MonthRef {
  /** 0–11, как в `Date`. */
  month: number;
  year: number;
}

/** Ключ дня `yyyy-MM-dd` по локальной дате: дата матча приходит в UTC, а день в календаре — локальный. */
export const toDayKey = (date: Date): string => format(date, 'yyyy-MM-dd');

/** Ключ месяца `yyyy-MM`. */
export const toMonthKey = ({ month, year }: MonthRef): string => format(new Date(year, month, 1), 'yyyy-MM');

/** Обратное к `toMonthKey`: `yyyy-MM` → месяц (0–11) и год. */
export function fromMonthKey(key: string): MonthRef {
  const [year, month] = key.split('-').map(Number);
  return { month: month - 1, year };
}

/** Месяц, сдвинутый на `delta` месяцев (в обе стороны, через границу года). */
export function shiftMonth({ month, year }: MonthRef, delta: number): MonthRef {
  const shifted = addMonths(new Date(year, month, 1), delta);
  return { month: shifted.getMonth(), year: shifted.getFullYear() };
}

/** Видимые месяцы подряд, начиная с `start`. */
export function getVisibleMonths(start: MonthRef, count = VISIBLE_MONTHS_COUNT): MonthRef[] {
  return Array.from({ length: count }, (_, index) => shiftMonth(start, index));
}
